import React from 'react'
import { useAuthContext } from '../contexts/AuthContext'
import { Navigate } from 'react-router-dom'

export default function PrivateRoutesForAdmin({ Component }) {
    const { isAuth, user } = useAuthContext()


    if (!isAuth && user.role !== "superAdmin") return <Navigate to={"/auth/login"} />
    if (isAuth && user.role !== "superAdmin") return <Navigate to={"/dashboard"} />



    return <Component />
}
